import { render, staticRenderFns } from "./aliRecharge.vue?vue&type=template&id=2b965fd2&scoped=true&"
import script from "./aliRecharge.vue?vue&type=script&lang=js&"
export * from "./aliRecharge.vue?vue&type=script&lang=js&"
import style0 from "./aliRecharge.vue?vue&type=style&index=0&id=2b965fd2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b965fd2",
  null
  
)

export default component.exports